import { render } from "./flashOption.vue?vue&type=template&id=3c15c81a&scoped=true"
import script from "./flashOption.vue?vue&type=script&lang=js"
export * from "./flashOption.vue?vue&type=script&lang=js"

import "./flashOption.vue?vue&type=style&index=0&id=3c15c81a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c15c81a"]])

export default __exports__